import { useState } from "react";
import './App.css';

function App() {
  const [tagData, setTagData] = useState("Nog niets gescand");
  
  const remarks = "-+-";

  async function getData(serNum) {
    //const response = await fetch("http://37.252.125.208/check.php?card=" + serNum);
    //const data = await response.text();
    //console.log(data);
    
    remarks = "boe";
    //alert(data.status);
    return;

  }


  async function scanNFC() {
    if (!("NDEFReader" in window)) {
      setTagData("Web NFC wordt niet ondersteund op dit apparaat.");
      return;
    }

    try {
      const ndef = new window.NDEFReader();
      await ndef.scan();

      setTagData("Scan gestart...");

      ndef.onreading = (event) => {
        /*const decoder = new TextDecoder();
        for (const record of event.message.records) {
          const text = decoder.decode(record.data);
          setTagData(text);
        }*/      
        getData(event.serialNumber);

        setTagData(event.serialNumber);
       
      };

    } catch (error) {
      setTagData("Fout bij scannen.");
      console.error(error);
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>NFC Scanner</h1>
      <button onClick={scanNFC}>Start scan</button>
      <p>{tagData}</p>
      <p>{remarks}</p>
      <p>Test ...</p>
    </div>
  );
}

export default App;